"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
/**
 * @param query {string} - For example: (max-width: 575.95px)
 */
function useMediaQuery(query) {
    const formattedQuery = query.replace('@media', '').trim();
    const getMatches = (query) => {
        // Prevents SSR issues
        if (typeof window !== 'undefined') {
            return window.matchMedia(query).matches;
        }
        return false;
    };
    const [matches, setMatches] = (0, react_1.useState)(getMatches(formattedQuery));
    function handleChange() {
        setMatches(getMatches(formattedQuery));
    }
    (0, react_1.useEffect)(() => {
        const matchMedia = window.matchMedia(formattedQuery);
        // Triggered at the first client-side load and if query changes
        handleChange();
        // Listen matchMedia
        const eventName = 'change';
        matchMedia.addEventListener(eventName, handleChange);
        return () => {
            matchMedia.removeEventListener(eventName, handleChange);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [formattedQuery]);
    return matches;
}
exports.default = useMediaQuery;
